import { render } from "./App.vue?vue&type=template&id=7feccaea"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7feccaea&lang=css"
script.render = render

export default script